import { nanoid } from 'nanoid'
import { getCanvasCoord, getPathInitialData } from '../../utils/utils.js'

/**
 * 도형 도구 시작 처리
 * - 시작 위치에 도형 path 초기화
 */

export const handleShapeDown = (e, state) => {
  const {
    paths,
    currentPath,
    currentPathId,
    selectedTool,
    selectedShape,
    clientCoord,
    scope,
    translate,
    isShapeFilled,
    thicknessVal,
    opacityVal,
    colorVal,
    previousPenPoint,
    // [동시편집]
    triggerAddPath,
  } = state

  // 현재 마우스/터치 좌표를 캔버스 좌표로 변환
  const canvasCoord = getCanvasCoord(clientCoord, translate, scope)

  // 새로운 path ID 생성
  const t = nanoid()
  currentPathId.current = t

  currentPath.current = getPathInitialData(
    selectedShape,
    Object.keys(paths).length,
    canvasCoord.x,
    canvasCoord.y,
    canvasCoord.x,
    canvasCoord.y,
    canvasCoord.x,
    canvasCoord.y,
    thicknessVal[selectedTool],
    opacityVal[selectedTool],
    colorVal[selectedTool],
    thicknessVal[selectedTool],
    isShapeFilled ? colorVal[selectedTool] : 'none',
    e.pressure,
    false,
    1
  )
  previousPenPoint.current = canvasCoord

  // 상태 업데이트
  // paths[t] = currentPath.current
  triggerAddPath(t, currentPath.current)
}
